/*
 * Public API Surface of @itavan/core-supabase
 */

export * from './src/database.types';
export * from './src/project.types';

// Configuration
export * from './src/supabase.config';

// Core services
export * from './src/supabase.core';
export * from './src/supabase.database';
export * from './src/supabase.functions';
export * from './src/supabase.session';
export * from './src/supabase.storage';

// Providers (modern approach)
export * from './src/supabase.providers';
